module.exports = __webpack_public_path__ + "img/fyt_p3.db5157ac.png";